/**
 * Toggle between email and phone number input
 */

import { Switch } from '@shared/components/ui/switch'
import { cn } from '@shared/lib/utils'
import { Mail, Phone } from 'lucide-react'

interface EmailPhoneToggleProps {
  isPhone: boolean
  onToggle: (isPhone: boolean) => void
  disabled?: boolean
}

export function EmailPhoneToggle({ isPhone, onToggle, disabled = false }: EmailPhoneToggleProps) {
  return (
    <div className={cn(
      'flex items-center justify-between p-3 rounded-lg transition-all duration-300',
      isPhone
        ? 'bg-gradient-to-l from-ring/50 to-white'
        : 'bg-gradient-to-r from-ring/50 to-white'
    )}>
      <div className="flex items-center gap-2">
        <Mail className={cn(
          'h-4 w-4 transition-colors',
          !isPhone ? 'text-primary' : 'text-muted-foreground'
        )} />
        <span className={cn(
          'text-sm font-medium transition-colors',
          // !isPhone ? 'text-foreground' : 'text-muted-foreground'
          !isPhone ? 'text-primary' : 'text-muted-foreground'
        )}>
          Email
        </span>
      </div>

      <Switch
        className='data-[state=checked]:bg-ring data-[state=unchecked]:bg-ring'
        checked={isPhone}
        onCheckedChange={onToggle}
        disabled={disabled}
        aria-label="Alternar entre email y teléfono"
      />

      <div className="flex items-center gap-2">
        <span className={cn(
          'text-sm font-medium transition-colors',
          // isPhone ? 'text-foreground' : 'text-muted-foreground'
          isPhone ? 'text-primary' : 'text-muted-foreground'
        )}>
          Teléfono
        </span>
        <Phone className={cn(
          'h-4 w-4 transition-colors',
          isPhone ? 'text-primary' : 'text-muted-foreground'
        )} />
      </div>
    </div>
  )
}
